import React from 'react'
import ReactDOM from 'react-dom/client'
import './index.css'
import App from './App'
import reportWebVitals from './reportWebVitals'
import "./i18next"

const root = ReactDOM.createRoot(document.getElementById('root'))

root.render(
  <App />
)

reportWebVitals()